import { MSGItemBody } from "./msg";
import { SDKHumanParticipantType } from "./sdk";
import { UserDefaultType } from "./user";

export type LanguageCode = 'en-us' | 'es-ES' | 'fr-FR' | 'de' | 'it' | 'nl' | 'ja' | "pt-BR"| "ko"| "zh-CN" | string | null


export type SupportedLanguage = {
    apiKeyName: string,
    detectLanguageCode: string,
    displayName: string,
    languageCode: string,
    notificationMessage: string,
    [key: string]: string,
};

export const SUPPORTED_LANGUAGES: Array<SupportedLanguage> = [
    {
        apiKeyName: 'German',
        detectLanguageCode: 'de',
        displayName: 'Deutsch',
        languageCode: 'de',
        notificationMessage: 'Momentan sind keine deutschsprachigen Agenten verfügbar, daher werden automatische Übersetzungsdienste verwendet, um Ihren Chat mit unserem Support-Spezialisten zu unterstützen.',
    },
    {
        apiKeyName: 'English',
        detectLanguageCode: 'en',
        displayName: 'English',
        languageCode: 'en-us',
        notificationMessage: 'There are no English speaking agents available at this time, so automatic translation services will be used to support your chat with our Support Specialist.',
    },
    {
        apiKeyName: 'Spanish',
        detectLanguageCode: 'es',
        displayName: 'Español',
        languageCode: 'es-ES',
        notificationMessage: 'En este momento no hay agentes que hablen español disponibles, por lo que se utilizarán servicios de traducción automática para apoyar su chat con nuestro Especialista de Soporte.',
    },
    {
        apiKeyName: 'French',
        detectLanguageCode: 'fr',
        displayName: 'Français',
        languageCode: 'fr-FR',
        notificationMessage: "À l'heure actuelle, aucun agent francophone n'est disponible, des services de traduction automatique seront donc utilisés pour soutenir votre discussion avec notre spécialiste du support.",
    },
    {
        apiKeyName: 'Italian',
        detectLanguageCode: 'it',
        displayName: 'Italiano',
        languageCode: 'it',
        notificationMessage: "Al momento non sono disponibili agenti che parlino italiano, pertanto per supportare la chat con il nostro specialista dell'assistenza verranno utilizzati servizi di traduzione automatica.",
    },
    {
        apiKeyName: 'Dutch',
        detectLanguageCode: 'nl',
        displayName: 'Nederlands',
        languageCode: 'nl',
        notificationMessage: 'Momenteel zijn er geen Nederlandstalige medewerkers beschikbaar. Daarom maken we gebruik van automatische vertaaldiensten om uw chat met onze ondersteuningsspecialist te ondersteunen.',
    },
    {
        apiKeyName: 'Portuguese (Brazil)',
        detectLanguageCode: 'pt-BR',
        displayName: 'Português',
        languageCode: 'pt-BR',
        notificationMessage: "No momento não há atendentes disponíveis para falar em português. Por isso, estamos usando serviços de tradução automática para apoiar sua conversa com nosso especialista do suporte.",
    },
    {
        apiKeyName: 'Japanese',
        detectLanguageCode: 'ja',
        displayName: '日本語',
        languageCode: 'ja',
        notificationMessage: '現時点では日本語を話せるエージェントはいませんので、サポート スペシャリストとのチャットには自動翻訳サービスが使用されます。',
    },
    {
        apiKeyName: 'Chinese (Simplified)',
        detectLanguageCode: 'zh-CN',
        displayName: '中国人',
        languageCode: 'zh-CN',
        notificationMessage: '目前没有能说普通话的代理，因此将使用自动翻译服务来支持您与我们的支持专家的聊天',
    },
    {
        apiKeyName: 'Chinese (Traditional)',
        detectLanguageCode: 'zh-TW',
        displayName: '中文',
        languageCode: 'zh-TW',
        notificationMessage: '目前没有能说普通话的代理，因此将使用自动翻译服务来支持您与我们的支持专家的聊天',
    },
    {
        apiKeyName: 'Korean',
        detectLanguageCode: 'ko',
        displayName: '한국인',
        languageCode: 'ko',
        notificationMessage: '현재 한국어 상담원이 없으므로 자동 번역 서비스를 사용하여 지원 전문가와의 채팅을 지원하게 됩니다.'
    },

] as const;

export function getLanguageByString(languageCode: string): SupportedLanguage | undefined{
    return SUPPORTED_LANGUAGES.find(language=>language.languageCode.toLowerCase() === languageCode.replace("_", "-").toLowerCase())
}

export type LanguageSession = { AgentLanguage: LanguageCode, UserLanguage: LanguageCode, status: boolean }
export type TranslationConfig = {
    sourceLanguage: LanguageCode,
    targetLanguage: LanguageCode
}

export interface LanguageContextType {
    AgentLanguage: LanguageCode;
    UserLanguage: LanguageCode;
    status: boolean,
    setStatus: (status: boolean) => void;
    setAgentLanguage: (language: LanguageCode) => void;
    setUserLanguage: (language: LanguageCode) => void;
    translateMessage: (message: string | MSGItemBody, sender: SDKHumanParticipantType) => Promise<string>
    saveTranscript: (message:string, messageId: string, from:SDKHumanParticipantType, user:UserDefaultType, engagementId: string) => void
    translateMessageWithLanguages: (message: string | MSGItemBody, sender: SDKHumanParticipantType, userLanguage: LanguageCode, agentLanguage: LanguageCode) => Promise<string>
    getLanguageByString: (message: string) => LanguageCode | null
    getAgentLanguage: (engagementId: string) => any
    resetLanguage: ()=> void
}